var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyJobNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 5.5H19.25V3C19.25 1.6125 18.1375 0.5 16.75 0.5H9.25C7.8625 0.5 6.75 1.6125 6.75 3V5.5H3C1.6125 5.5 0.5 6.6125 0.5 8V21.75C0.5 23.1375 1.6125 24.25 3 24.25H23C24.3875 24.25 25.5 23.1375 25.5 21.75V8C25.5 6.6125 24.3875 5.5 23 5.5ZM9.25 3H16.75V5.5H9.25V3ZM23 21.75H3V19.25H23V21.75ZM23 15.5H3V8H6.75V10.5H9.25V8H16.75V10.5H19.25V8H23V15.5Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyJobNew);
export default __webpack_public_path__ + "static/media/company-job-new.75d542ca366c93d4ae131e7c176189af.svg";
export { ForwardRef as ReactComponent };